const formatDuration = (durationSeconds) => {
  const minutes = Math.floor(durationSeconds / 60)
  const seconds = durationSeconds - minutes * 60
  return `${minutes}m ${seconds}s`
}

export default formatDuration
